// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__60w_B","file":"styles_file__un9vc"};